import { render, staticRenderFns } from "./FormBuilderDetailStateCard.vue?vue&type=template&id=1d0d60e2&"
import script from "./FormBuilderDetailStateCard.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderDetailStateCard.vue?vue&type=script&lang=ts&"
import style0 from "./FormBuilderDetailStateCard.vue?vue&type=style&index=0&id=1d0d60e2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports